import { render, staticRenderFns } from "./ShareToEditModal.vue?vue&type=template&id=2389b6a2&scoped=true&"
import script from "./ShareToEditModal.vue?vue&type=script&lang=js&"
export * from "./ShareToEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareToEditModal.vue?vue&type=style&index=0&id=2389b6a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389b6a2",
  null
  
)

export default component.exports